import React from "react";
import { Modal } from "react-bootstrap";
import DatesPicker from ".";

const ModalPicker = ({ show, onHide, onOk }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <div className="container mb-3 mt-3">
        <h5>Seleccione un rango de fechas</h5>
        <br />
        <DatesPicker onOk={onOk} />
      </div>
    </Modal>
  );
};

export default ModalPicker;
